import { OwaDate, addMilliseconds, differenceInMilliseconds, now } from 'owa-datetime';
import getSelectedFolderViewState from '../selectors/getSelectedFolderView';
import selectTodoById from '../selectors/selectTodoById';

const HOUR_IN_MILLISECONDS = 1 * 60 * 60 * 1000;

/**
 * Computes the Order for the task
 * @param targetIndex The index of the task over which item is being dropped.
 * Note: Tasks are in descending order of Order.
 */
export default function getOrderTimeForDrop(
    targetIndex: number,
    countOfDroppedItems: number = 1
): OwaDate[] {
    const todoIds = getSelectedFolderViewState().activeTaskIds;

    // If there are no todos at all, there's no relative Order time to compute against
    // So select now()
    if (todoIds.length === 0) {
        return generateSeriesFromStartTime(countOfDroppedItems, now());
    }

    // If drop is after last item, use 1 hour earlier than last item.
    if (targetIndex >= todoIds.length) {
        const lastOrderTime = selectTodoById(todoIds[todoIds.length - 1]).OrderDateTime;
        const orderTime = addMilliseconds(lastOrderTime, -1 * HOUR_IN_MILLISECONDS);
        return generateSeriesFromStartTime(countOfDroppedItems, orderTime);
    }

    // Find a date between this task and the previous one.
    // If there's no previous item (dropped on index 0), use now as max time.
    const minDateTime = selectTodoById(todoIds[targetIndex]).OrderDateTime;
    const maxDateTime =
        targetIndex === 0 ? now() : selectTodoById(todoIds[targetIndex - 1]).OrderDateTime;
    return generateSeriesInRange(countOfDroppedItems, maxDateTime, minDateTime);
}

export function generateSeriesFromStartTime(
    countOfDroppedItems: number,
    startDateTime: OwaDate
): OwaDate[] {
    const retOrders = [];
    for (let index = 0; index < countOfDroppedItems; index++) {
        retOrders.push(addMilliseconds(startDateTime, -1 * index * HOUR_IN_MILLISECONDS));
    }

    return retOrders;
}

export function generateSeriesInRange(
    countOfDroppedItems: number,
    maxDateTime: OwaDate,
    minDateTime: OwaDate
): OwaDate[] {
    const retOrders = [];
    const step = differenceInMilliseconds(maxDateTime, minDateTime) / (countOfDroppedItems + 1);

    // Start iterating at 1, not 0, otherwise first value will be minDateTime.
    for (let index = 1; index <= countOfDroppedItems; index++) {
        retOrders.push(addMilliseconds(minDateTime, index * step));
    }

    return retOrders;
}
